import { createContext } from 'react'

// Shared context - imported by both Provider and hook
export const NotificationContext = createContext()
export const AuthContext = createContext()
